// extracted by mini-css-extract-plugin
module.exports = {"dialog-wrap":"style_dialog-wrap__3ulmt","dialog-box":"style_dialog-box__kz5c1","content":"style_content__3OHvv","btn":"style_btn__1CRf-"};